import { AnestheticGas } from "requests";

export const generateAnestheticGasesData = (
  anestheticGases: AnestheticGas[]
) => {
  if (anestheticGases?.length > 0) {
    return anestheticGases.reduce(
      (acc: any, el) => {
        return acc.map((accEl: any) => {
          if (accEl.name === "Inhalant Anesthetic Agent (%)") {
            accEl.val = [
              ...accEl.val,
              {
                anestheticGasesId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.inhalantAnestheticAgent
              }
            ];
          }
          if (accEl.name === "Oxygen L/min") {
            accEl.val = [
              ...accEl.val,
              {
                anestheticGasesId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.oxygen
              }
            ];
          }
          return accEl;
        });
      },
      [
        {
          name: "Inhalant Anesthetic Agent (%)",
          _id: 0,
          val: []
        },
        {
          name: "Oxygen L/min",
          _id: 1,
          val: []
        }
      ]
    );
  }

  return [];
};
